import React from 'react';
import DropDown from './DropDown';
import translations from '../../translations';
import Tenant from './Tenant';
import DropdownListLink from './headerDropdown/DropdownListLink';
import DropdownListButton from './headerDropdown/DropdownListButton';
import DropdownButton from './headerDropdown/DropdownButton';

import { connect } from 'react-redux';
import { APP_LINKS, HELP_LINKS, SYSTEM_ROLES } from '../../constants';

export const HeaderNav = ({ currentUser }) => {

    const settingsScreens = {
        orgs: 'organization',
        tenant: 'tenant',
        stores: 'data-stores',
    };

    const headerNavConfig = [
        {
            buttonContents: (
                <DropdownButton buttonText={translations['appswitcher buttontext']} />
            ),
            listClass: '',
            links: [
                {
                    text: translations['integration linktext'],
                    summary: translations['integration summarytext'],
                    action: APP_LINKS.integration,
                },
                {
                    text: translations['datahub linktext'],
                    summary: translations['datahub summarytext'],
                    action: APP_LINKS.datahub,
                },
                {
                    text: translations['apimgnt linktext'],
                    summary: translations['apimgnt summarytext'],
                    action: APP_LINKS.apimgnt,
                },
            ],
            buttons: [],
        },
        {
            buttonContents: (
                <DropdownButton buttonText={translations['help buttontext']} />
            ),
            listClass: 'help-dropdown-list',
            links: [
                { 
                    text: translations['docs linktext'],
                    summary: translations['docs summarytext'],
                    action: HELP_LINKS.docs,
                },
                {
                    text: translations['support linktext'],
                    summary: translations['support summarytext'],
                    action: HELP_LINKS.support,
                },
                {
                    text: translations['community linktext'],
                    summary: translations['community summarytext'],
                    action: HELP_LINKS.community,
                },
                {
                    text: translations['training linktext'],
                    summary: translations['training summarytext'],
                    action: HELP_LINKS.training,
                },
            ],
            buttons: [],
        },
        {
            buttonContents: (
                <DropdownButton buttonText={translations['settings buttontext']} />
            ),
            listClass: 'settings-dropdown-list',
            links: [],
            buttons: [
                {
                    text: translations['organization linktext'],
                    summary: translations['organization summarytext'],
                    screen: settingsScreens.orgs,
                    icon: 'glyphicon-briefcase',
                },
                {
                    text: translations['tenant linktext'],
                    summary: translations['tenant summarytext'],
                    screen: settingsScreens.tenant,
                    icon: 'glyphicon-tree-deciduous',
                },
            ],
        },
    ];

    if (currentUser.roleName !== SYSTEM_ROLES.administrator.developerName) {
        headerNavConfig.pop();
    }

    return (
        <ul className="tab-header-admin header-admin-left">

            {headerNavConfig.map(config => (
                <li key={config.listClass}>
                    <DropDown buttonContents={config.buttonContents}>
                        <ul className={`list-unstyled dropdown-list ${config.listClass}`}>
                            {config.links.map(link => <DropdownListLink key={link.text} linkText={link.text} linkSummary={link.summary} linkHref={link.action} />)}
                            {config.buttons.map(button => (
                                <DropdownListButton
                                    key={button.text}
                                    navigateTo={button.screen}
                                    buttonText={button.text}
                                    buttonSummary={button.summary}
                                    iconClass={button.icon}
                                    tenantId={currentUser.tenantId}
                                />
                            ))}
                        </ul>
                    </DropDown>
                </li>
            ))}
            <Tenant />
        </ul>
    );
};

const mapStateToProps = ({ currentUser }) => ({ currentUser });

export default connect(
    mapStateToProps,
)(HeaderNav);
